import { temAcesso } from '@/shared/auth/temAcesso'

const Comprometimentos = () => import('./Comprometimentos.vue')

export default {
    path: 'aprovadores',
    name: 'GesconAprovadores',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-COMP-APROV-00')) {
            next()
        }
    },
    children: [
        {
            path: 'servicos',
            name: 'GesconAprovadoresComprometimentos',
            component: Comprometimentos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-COMP-APROV-00')) {
                    next()
                }
            }
        }
    ]
}
